<template>
  <section class="global-background-footer">
    <div class="container submit-area">
      <div class="footer-steps">

      </div>
      <!-- Verstuur Enquete -->
      <div class="columns is-centered">
        <div class="column is-full intro-message">
          <div class="column">
            <b-checkbox :style="notAgreedToPrivacy ? 'color:red' : ''" v-model="agreedToPrivacy">Met het versturen van dit formulier ga ik ermee akkoord dat Prestatiedatabank mijn persoonsgegevens verwerkt, zoals beschreven in het <router-link to="/privacy">privacybeleid</router-link></b-checkbox>
          </div>
          <a @click="SendForm()" :disabled="!isFinished() || hasSubmitted" class="button is-medium has-text-weight-bold is-rounded send-button" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">{{ sendButtonText }}</a>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import axios from 'axios'

const endpoint = '/survey/edit'

import FormSteps from '../footer/FormSteps'

export default {
  name: 'SubmitForm',
  components: {
    'form-steps': FormSteps
  },
  data () {
    return {
      sendButtonText: 'Verstuur enquête',
      showNav: true,
      activities: this.$store.getters.getActivities,
      survey: this.$store.getters.getSurvey,
      hasSubmitted: false,
      agreedToPrivacy: false,
      notAgreedToPrivacy: false
    }
  },
  methods: {
    isFinished() {
      if (this.$store.getters.getSurveyType == 'single-page-survey') {
        return true
      } else {
        var showEnd = false;
        var active = this.$store.getters.getActiveActivity;

        if (this.$store.getters.GetSendIsActive || active == this.activities.length - 1) {
          this.$store.commit('SetSendIsActive', true);
          showEnd = true;
        }
        return showEnd;

      }


    },
    validate () {
      let valid = true

      let activities = this.$store.getters.getActivities ? this.$store.getters.getActivities : [];

      activities.forEach((activity) => {

        activity.filteredQuestions.forEach((question) => {

          if (question.question_type == 'checkbox' && question.answer == null) question.answer = false;

          if (question.status == 1 && question.required == 1 && question.type != 1) {
            if (question.question_type == 'text' || question.question_type == 'value_unit' || question.question_type == 'value' || question.question_type == 'calendar') {
              if (question.answer == '' || question.answer == null) valid = false;
            }
            else if (question.question_type == 'checkbox_multiple_multiple') {
              if (question.answer == null) valid = false;
              else if (question.answer.length == 0) valid = false;
            } else if (question.question_type == 'select_rating_text' || question.question_type == 'select_rating' || question.question_type == 'radio_multiple_one' || question.question_type == 'select_multiple_one') {
              if ((question.answer == '' || question.answer == null) && !question.doesNotApply) valid = false;
            }
          }
          
        })
      })
      return valid
    },
    SendForm() {
      if (!this.agreedToPrivacy) {
        this.notAgreedToPrivacy = true;
        return;
      }

      this.$store.commit('setValidate', true)
      let result = this.validate()
      this.survey.activities = this.activities
      if (this.isFinished() && result) {
        this.hasSubmitted = true;
        let surveyPost = this.trimSurvey(this.survey);
        
        surveyPost.activities.forEach(activity => {
          activity.questions = activity.questions.filter(question => question.type === 0)
        })

        this.$http
            .post(process.env.EMET_API_URL + endpoint, { survey: surveyPost, token: this.$store.getters.getToken }, {emulateJSON: true})
            .then((response) => {
              // console.log(response)
              if (response.data.status) {
                  this.$store.commit('setSurveyActive', false)
                  this.$store.commit('setSurveySubmited', true)
                  if (!this.$store.getters.getSurveyActive) {
                    // this.$router.push({name: 'end'})
                    console.log('Form successful sent')
                    this.$emit('submitted')
                  }
              } else {
                  alert('error')
              }


              this.$store.commit('setSurvey', this.survey)
            }, (error) => {
              this.$store.commit('setSurvey', this.survey)
              alert('error')
            })
      } else {
        this.changeButtonText('Vul alle vragen in...', 3000)
      }



      // this.$http.post(process.env.EMET_API_URL + endpoint, { survey: this.survey, token: this.$store.getters.getToken }, {emulateJSON: true})
      //     .then(function (response) {
      //         if (response.data.status) {
      //             this.$store.commit('setSurveyActive', false)
      //             this.$store.commit('setSurveySubmited', true)
      //             if (!this.$store.getters.getSurveyActive) this.$router.push({name: 'end'})
      //         } else {
      //             alert('error')
      //         }
      //         this.$store.commit('setSurvey', this.survey)
      //     }, function (response) {
      //         this.$store.commit('setSurvey', this.survey)
      //         alert('error')
      //     })
    },
    trimSurvey(survey) {
      let copy = JSON.parse(JSON.stringify(survey));
      let activities = copy.activities;
      for (let i in activities) {
        activities[i]['filteredQuestions'] = null;
        for (let j in activities[i]['questions']) {
          activities[i]['questions'][j]['values'] = null;
        }
      }
      return copy;
    },
    changeButtonText (text, timeout) {
      let oldText = this.sendButtonText
      this.sendButtonText = text;
      setTimeout(() => {
        this.sendButtonText = oldText
      }, timeout)
      // console.log(oldText);
    }
  }
}
</script>

<style scoped>

.submit-area {
  padding-top: 60px;
  padding-bottom: 100px;
  text-align: center;
}

.send-button {
  background-color: #00294c;
  border-color: #00294c;
  font-size: 18px;
  font-weight: bold;
  color: white;
  padding-bottom: 7px;
  width: 200px;
  transition: width 0.3s;
  z-index: 10;
}

.send-button:hover {
  background-color: #335470;
  border-color: #003766;
  font-weight: bold;
  color: white;
  padding-bottom: 7px;
  width: 220px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/footer/SubmitForm.vue